import { configureStore } from '@reduxjs/toolkit';
import reducers from './index';

const store = configureStore({
  reducer: reducers,
  devTools: process.env.NODE_ENV !== 'production', // only enable the Redux devtools in development mode
});

export default store;
